/* Clipz-it, suivi des articles de blog. Pose le 28/09/2026 par le PILOTAGE, sur demande de Thibaut :
   « rajoute au tracking les interactions avec les blogs, qu'on sache si les blogs nous ont ramene des ventes ».

   POURQUOI CE FICHIER EXISTE ET PAS UN SIMPLE gtag(). Le GA4 de la boutique, G-N1GV349CGQ, est injecte
   par le canal Google dans le BAC A SABLE des pixels Shopify. Mesure du 28/09 sur une fiche article
   servie en direct : zero occurrence de `gtag(` dans le document, le seul chargeur present est
   web-pixels-manager. Aucun script de theme ne peut donc emettre un evenement GA4 directement. La
   seule passerelle officielle est Shopify.analytics.publish, qu'un pixel personnalise reecoute.

   ET POURQUOI IL N'Y A PAS QUE DES EVENEMENTS. Un evenement d'analyse se perd : consentement refuse,
   bloqueur, modelisation, echantillonnage. La question posee est une question d'argent, et elle se
   repond sur la COMMANDE. Le script inscrit donc l'article lu dans les ATTRIBUTS DU PANIER, prefixes
   d'un souligne donc prives, invisibles du client, qui remontent tels quels dans la commande Shopify
   et se relisent par l'API. C'est exact, c'est de la donnee de premiere main, et cela ne depend
   d'aucun outil tiers ni d'aucune modelisation.

   CONSENTEMENT. Les evenements publies par Shopify.analytics.publish sont delivres aux pixels par le
   gestionnaire de Shopify, qui applique lui-meme le consentement du visiteur : rien a regler ici.
   Les attributs de panier sont de la donnee de commande de premiere main, pas du profilage.

   ROLLBACK. Retirer la ligne {% render 'cz-blog-suivi' %} de layout/theme.liquid. Le script ne touche
   a rien d'autre : aucun ajout au panier, aucune modification de prix, aucune ecriture hors attributs.
*/
(function () {
  'use strict';

  var CLE = 'cz_blog_v1';
  var FENETRE = 30 * 24 * 60 * 60 * 1000; // 30 jours de memoire de lecture
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function lire() {
    try {
      var b = JSON.parse(window.localStorage.getItem(CLE) || 'null');
      if (!b || !b.t || Date.now() - b.t > FENETRE) return null;
      return b;
    } catch (e) { return null; }
  }

  function ecrire(b) {
    try { window.localStorage.setItem(CLE, JSON.stringify(b)); } catch (e) {}
  }

  function publier(nom, charge) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(nom, charge);
      }
    } catch (e) {}
  }

  /* --- 1. L'article lu ------------------------------------------------------------------ */

  var art = window.czBlog;

  if (art && art.handle) {
    var b = lire() || { premier: art.handle, articles: [], clic: '' };
    b.dernier = art.handle;
    b.t = Date.now();
    if (!b.premier) b.premier = art.handle;
    if (b.articles.indexOf(art.handle) < 0) b.articles.push(art.handle);
    if (b.articles.length > 5) b.articles = b.articles.slice(-5);
    ecrire(b);

    publier('cz_blog_article_vu', {
      article: art.handle, titre: art.titre, blog: art.blog, langue: art.langue
    });

    /* Lecture reelle : 60 % de l'article parcouru, ou trente secondes onglet actif. Un article
       ouvert et referme aussitot n'est pas une lecture, et le distinguer est tout l'interet. */
    var lu = false;
    function marquerLu(cause) {
      if (lu) return;
      lu = true;
      publier('cz_blog_lu', { article: art.handle, titre: art.titre, cause: cause });
    }
    var corps = document.querySelector('.article-content') || document.querySelector('.article');
    function auScroll() {
      if (lu || !corps) return;
      var r = corps.getBoundingClientRect();
      // Part de l'article deja passee sous le bas de la fenetre.
      if (r.height > 0 && (window.innerHeight - r.top) / r.height >= 0.6) marquerLu('scroll');
    }
    window.addEventListener('scroll', auScroll, { passive: true });
    var secondes = 0;
    var compteur = setInterval(function () {
      if (document.visibilityState === 'visible') secondes += 5;
      if (secondes >= 30) { marquerLu('duree'); clearInterval(compteur); }
    }, 5000);

    /* Clic de l'article vers une fiche ou une collection : c'est le geste qui transforme un
       lecteur en acheteur potentiel, et c'est lui qu'on veut pouvoir compter. */
    document.addEventListener('click', function (e) {
      try {
        var dans = e.target.closest && e.target.closest('.article-content, .article');
        if (!dans) return;
        var a = e.target.closest('a[href]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        var type = href.indexOf('/products/') > -1 ? 'produit'
                 : href.indexOf('/collections/') > -1 ? 'collection' : '';
        if (!type) return;
        var etat = lire() || { premier: art.handle, articles: [art.handle], clic: '' };
        etat.clic = href.split('?')[0];
        etat.t = Date.now();
        ecrire(etat);
        publier('cz_blog_vers_produit', {
          article: art.handle, titre: art.titre, cible: etat.clic, type: type
        });
      } catch (err) {}
    }, true);
  }

  /* --- 2. Le report sur la commande ------------------------------------------------------ */

  /* On n'ecrit les attributs QUE si le panier contient deja quelque chose, et seulement quand ils
     different de ce qui s'y trouve : un panier vide n'est pas une vente, et une ecriture inutile
     est une requete de plus sur le chemin du client. */
  function synchroniserPanier() {
    var b = lire();
    if (!b) return;
    fetch(racine + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.item_count) return;
        var att = p.attributes || {};
        var voulu = {
          _blog_origine: b.premier || '',
          _blog_dernier: b.dernier || '',
          _blog_clic: b.clic || '',
          _blog_articles: String((b.articles || []).length)
        };
        var change = false;
        for (var k in voulu) { if ((att[k] || '') !== voulu[k]) change = true; }
        if (!change) return;
        fetch(racine + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: voulu })
        }).catch(function () {});
      })
      .catch(function () {});
  }

  /* L'ajout au panier passe par fetch dans ce theme. On observe l'appel sans le modifier :
     la promesse d'origine est rendue telle quelle, le corps de la reponse n'est jamais lu. */
  if (window.fetch && !window.__czBlogPatch) {
    window.__czBlogPatch = true;
    var fetchOrigine = window.fetch;
    window.fetch = function (entree, init) {
      var url = '';
      try { url = (typeof entree === 'string') ? entree : ((entree && entree.url) || ''); } catch (e) {}
      var p = fetchOrigine.apply(this, arguments);
      if (url.indexOf('/cart/add') > -1) {
        try { p.then(function () { setTimeout(synchroniserPanier, 300); }, function () {}); } catch (e) {}
      }
      return p;
    };
  }

  /* Filet pour les chemins qui n'emploient pas fetch : formulaire classique, retour arriere,
     onglet repris. Sans marqueur de lecture, ces appels sortent immediatement. */
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (f && f.action && f.action.indexOf('/cart/add') > -1) setTimeout(synchroniserPanier, 800);
    } catch (err) {}
  }, true);

  window.addEventListener('pageshow', function () { setTimeout(synchroniserPanier, 200); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synchroniserPanier);
  } else {
    synchroniserPanier();
  }
})();
